import SaasConnectSettings from "../../../SaaSApps/shared/SaasConnectSettings";
import { SettingProps } from "../../interface";

export default function GitLabSettings({ onBack }: SettingProps) {
    return <SaasConnectSettings provider="gitlab" onBack={onBack} />;
}
